import React from 'react';
import { Link } from 'react-router-dom';
import RetroButton from '../ui/RetroButton';

const Cta = () => {
  return (
    <section className="py-24 border-b-4 border-retro-brown bg-retro-blue text-retro-cream relative overflow-hidden">
      {/* Decorative starburst */}
      <div className="absolute -top-20 -right-20 w-64 h-64 bg-retro-yellow border-4 border-retro-brown animate-spin-slow opacity-20" style={{clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)'}}></div>
      
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="font-display text-5xl md:text-7xl uppercase tracking-tighter mb-8 drop-shadow-[4px_4px_0_rgba(58,44,39,1)]">
          Ready to Be on the Card?
        </h2>
        <p className="font-body text-2xl font-bold mb-12 border-4 border-retro-brown bg-retro-cream text-retro-brown p-8 rounded-[2rem] shadow-retro inline-block">
          Spots fill fast — one per category, first come first served. Check availability for your neighborhood before someone else in your trade does.
        </p>
        <div>
          <Link to="/find-your-city">
            <RetroButton variant="primary" className="text-2xl !py-6 !px-12">
              Find Your City
            </RetroButton>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Cta;